import WordCloudWidget from '../../widgets/WordCloudWidget';
import { tryFetch } from '../../widgetLoader';
import { RELOAD_INTERVAL } from './common';

export default async function mountWordCloud(host) {
	const fetchWords = () => tryFetch(() => host.api.get(`widget/${encodeURIComponent(host.hash)}/words`), `cache-${host.hash}-words`);
	const load = async () => {
		const [ settings, words ] = await Promise.all([ host.loadSettings(), fetchWords() ]);
		return { settings: settings || {}, words: words || [] };
	};

	const widget = new WordCloudWidget({ container: host.container });
	await widget.init(await load());

	let wordRefreshTimer;
	function scheduleWordRefresh() {
		clearTimeout(wordRefreshTimer);
		const ms = (widget.settings.refreshInterval || 10) * 60 * 1000;
		wordRefreshTimer = setTimeout(async () => {
			const words = await fetchWords();
			if(words) widget.applyWords(words);
			scheduleWordRefresh();
		}, ms);
	}
	scheduleWordRefresh();

	host.onSettingsChange(s => {
		widget.applySettings(s);
		scheduleWordRefresh();
	});

	async function reload() {
		const d = await load();
		widget.applySettings(d.settings);
		widget.applyWords(d.words);
		scheduleWordRefresh();
	}

	host.subscribe({ reconnect: reload });
	host.every(reload, RELOAD_INTERVAL);
	host.onDestroy(() => {
		clearTimeout(wordRefreshTimer);
		widget.destroy();
	});
}
